import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {autobind} from 'core-decorators';
import classNames from 'classnames';
import * as builtinValidators from './validators';
import styles from './styles.css';

@autobind
export default class Form extends Component {
    static propTypes = {
        fields: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.string.isRequired,
            required: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
            initial: PropTypes.any,
            validators: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.func])),
        })).isRequired,
        errors: PropTypes.object,
        onSubmit: PropTypes.func.isRequired,
        children: PropTypes.func.isRequired,
    };

    static defaultProps = {
        errors: {},
    };

    static Actions = ({children, align = 'left'}) => (
        <div className={classNames(styles.actions, styles[align])}>{children}</div>
    );

    state = {
        values: {},
        shouldValidate: [],
    };

    componentWillMount() {
        this.processFields(this.props.fields);
    }

    componentWillReceiveProps(nextProps) {
        this.processFields(nextProps.fields);
    }

    processFields(fields) {
        const values = {};
        const shouldValidate = [];

        fields.forEach(field => {
            if (this.state.values[field.key] !== undefined) {
                values[field.key] = this.state.values[field.key];
            } else if (field.initial !== undefined) {
                values[field.key] = field.initial;
                // if (!this.state.shouldValidate.includes(field.key)) {
                //     shouldValidate.push(field.key);
                // }
            } else {
                values[field.key] = '';
            }
        });

        this.setState({
            values,
            shouldValidate: [...this.state.shouldValidate, ...shouldValidate],
        });
    }

    validateField(key) {
        const field = this.props.fields.find(field => field.key === key);
        const value = this.state.values[key];
        const hasValue = value !== undefined && value !== false && value.length !== 0;

        const required = typeof field.required === 'function'
            ? field.required(value, this.state.values)
            : field.required;

        if (required !== false && !hasValue) {
            return ['Este campo es obligatorio.'];
        }

        if (field.validators && hasValue) {
            const errors = field.validators
                .map(validator => {
                    const fn = typeof validator === 'function' ? validator : builtinValidators[validator];
                    return fn(value, this.state.values);
                })
                .filter(error => error !== true);

            if (errors.length > 0) return errors;
        }

        return true;
    }

    isValid() {
        return this.props.fields.every(field => {
            return this.validateField(field.key) === true;
        });
    }

    getFieldProps(key) {
        return {
            value: this.state.values[key],
            onChange: value => this.setState({values: {...this.state.values, [key]: value}}),
            onBlur: () => this.setState({shouldValidate: [...new Set([...this.state.shouldValidate, key])]}),
        };
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.onSubmit(this.state.values);
    }

    renderErrors(key) {
        let errors;

        if (this.props.errors[key]) {
            errors = this.props.errors[key];
        } else if (this.state.shouldValidate.includes(key)) {
            const result = this.validateField(key);
            if (result !== true) errors = result;
        }

        if (errors) {
            return (
                <ul className={styles.errors}>
                    {Array.isArray(errors) ? errors.map(error => <li key={error}>{error}</li>) : <li>{errors}</li>}
                </ul>
            );
        }
    }

    render() {
        return (
            <form className={styles.root} onSubmit={this.handleSubmit}>
                {this.props.children({
                    values: this.state.values,
                    getFieldProps: this.getFieldProps,
                    renderErrors: this.renderErrors,
                    isValid: this.isValid,
                })}
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./components/forms/form/index.js